/* Copyright (c) 2021-2026, NVIDIA CORPORATION.  All rights reserved.
*
* NVIDIA CORPORATION and its licensors retain all intellectual property
* and proprietary rights in and to this software, related documentation
* and any modifications thereto.  Any use, reproduction, disclosure or
* distribution of this software and related documentation without an express
* license agreement from NVIDIA CORPORATION is strictly prohibited.
*/

/** This file was automatically generated. DO NOT MODIFY IT BY HAND. */

/* eslint-disable @typescript-eslint/naming-convention */

import { BridgeCommands } from '../../../src/bridge.commands';

import { Types } from '../../types/index';

/** This object was automatically generated by generate-commands. DO NOT MODIFY IT BY HAND. */

const GetFirstBootTimeAfterInstall: BridgeCommands.Command<
    {},
    Types.Common.Downloader.GetFirstBootTimeAfterInstallReturn
    > = {
    legacyCommand: 'QUERY_IPC_EXTENSION_MESSAGE',
    system: 'CrimsonNative',
    module: 'Downloader',
    method: 'GetFirstBootTimeAfterInstall',
    persistent: false
};

/** This object was automatically generated by generate-commands. DO NOT MODIFY IT BY HAND. */

const GetMaxDaysBetweenReleases: BridgeCommands.Command<
    Types.Common.Downloader.GetMaxDaysBetweenReleasesParameters,
    Types.Common.Downloader.GetMaxDaysBetweenReleasesReturn
    > = {
    legacyCommand: 'QUERY_IPC_EXTENSION_MESSAGE',
    system: 'CrimsonNative',
    module: 'Downloader',
    method: 'GetMaxDaysBetweenReleases',
    persistent: false
};

/** This object was automatically generated by generate-commands. DO NOT MODIFY IT BY HAND. */

const CheckForUpdate: BridgeCommands.Command<
    Types.Common.Downloader.CheckForUpdateParameters,
    Types.Common.Downloader.CheckForUpdateReturn
    > = {
    legacyCommand: 'QUERY_IPC_EXTENSION_MESSAGE',
    system: 'CrimsonNative',
    module: 'Downloader',
    method: 'CheckForUpdate',
    persistent: false
};

/** This object was automatically generated by generate-commands. DO NOT MODIFY IT BY HAND. */

const GetLatestUpdateCheckTime: BridgeCommands.Command<
    Types.Common.Downloader.GetLatestUpdateCheckTimeParameters,
    Types.Common.Downloader.GetLatestUpdateCheckTimeReturn
    > = {
    legacyCommand: 'QUERY_IPC_EXTENSION_MESSAGE',
    system: 'CrimsonNative',
    module: 'Downloader',
    method: 'GetLatestUpdateCheckTime',
    persistent: false
};

/** This object was automatically generated by generate-commands. DO NOT MODIFY IT BY HAND. */

const GetTaskDownloadStatus: BridgeCommands.Command<
    Types.Common.Downloader.GetTaskDownloadStatusParameters,
    Types.Common.Downloader.DownloadProgressStatusReturn
    > = {
    legacyCommand: 'QUERY_IPC_EXTENSION_MESSAGE',
    system: 'CrimsonNative',
    module: 'Downloader',
    method: 'GetTaskDownloadStatus',
    persistent: false
};

/** This object was automatically generated by generate-commands. DO NOT MODIFY IT BY HAND. */

const GetDownloadStatus: BridgeCommands.Command<
    Types.Common.Downloader.GetDownloadStatusParameters,
    Types.Common.Downloader.DownloadProgressStatusReturn
    > = {
    legacyCommand: 'QUERY_IPC_EXTENSION_MESSAGE',
    system: 'CrimsonNative',
    module: 'Downloader',
    method: 'GetDownloadStatus',
    persistent: false
};

/** This object was automatically generated by generate-commands. DO NOT MODIFY IT BY HAND. */

const StartDownload: BridgeCommands.Command<
    Types.Common.Downloader.StartDownloadParameters,
    Types.Common.Downloader.DownloadProgressStatusReturn
    > = {
    legacyCommand: 'QUERY_IPC_EXTENSION_MESSAGE',
    system: 'CrimsonNative',
    module: 'Downloader',
    method: 'StartDownload',
    persistent: false
};

/** This object was automatically generated by generate-commands. DO NOT MODIFY IT BY HAND. */

const StartDownloadAndPostProcess: BridgeCommands.Command<
    Types.Common.Downloader.StartDownloadAndPostProcessParameters,
    Types.Common.Downloader.DownloadProgressStatusReturn
    > = {
    legacyCommand: 'QUERY_IPC_EXTENSION_MESSAGE',
    system: 'CrimsonNative',
    module: 'Downloader',
    method: 'StartDownloadAndPostProcess',
    persistent: false
};

/** This object was automatically generated by generate-commands. DO NOT MODIFY IT BY HAND. */

const ScheduleDownloadAndPostProcess: BridgeCommands.Command<
    Types.Common.Downloader.ScheduleDownloadAndPostProcessParameters,
    Types.Common.Downloader.DownloadProgressStatusReturn
    > = {
    legacyCommand: 'QUERY_IPC_EXTENSION_MESSAGE',
    system: 'CrimsonNative',
    module: 'Downloader',
    method: 'ScheduleDownloadAndPostProcess',
    persistent: false
};

/** This object was automatically generated by generate-commands. DO NOT MODIFY IT BY HAND. */

const PauseDownload: BridgeCommands.Command<
    Types.Common.Downloader.PauseDownloadParameters,
    Types.Common.Downloader.DownloadProgressStatusReturn
    > = {
    legacyCommand: 'QUERY_IPC_EXTENSION_MESSAGE',
    system: 'CrimsonNative',
    module: 'Downloader',
    method: 'PauseDownload',
    persistent: false
};

/** This object was automatically generated by generate-commands. DO NOT MODIFY IT BY HAND. */

const ResumeDownload: BridgeCommands.Command<
    Types.Common.Downloader.ResumeDownloadParameters,
    Types.Common.Downloader.DownloadProgressStatusReturn
    > = {
    legacyCommand: 'QUERY_IPC_EXTENSION_MESSAGE',
    system: 'CrimsonNative',
    module: 'Downloader',
    method: 'ResumeDownload',
    persistent: false
};

/** This object was automatically generated by generate-commands. DO NOT MODIFY IT BY HAND. */

const ResumeDownloadAndPostProcess: BridgeCommands.Command<
    Types.Common.Downloader.ResumeDownloadAndPostProcessParameters,
    Types.Common.Downloader.DownloadProgressStatusReturn
    > = {
    legacyCommand: 'QUERY_IPC_EXTENSION_MESSAGE',
    system: 'CrimsonNative',
    module: 'Downloader',
    method: 'ResumeDownloadAndPostProcess',
    persistent: false
};

/** This object was automatically generated by generate-commands. DO NOT MODIFY IT BY HAND. */

const StopDownload: BridgeCommands.Command<
    Types.Common.Downloader.StopDownloadParameters,
    Types.Common.Downloader.DownloadProgressStatusReturn
    > = {
    legacyCommand: 'QUERY_IPC_EXTENSION_MESSAGE',
    system: 'CrimsonNative',
    module: 'Downloader',
    method: 'StopDownload',
    persistent: false
};

/** This object was automatically generated by generate-commands. DO NOT MODIFY IT BY HAND. */

const GetPostProcessingStatus: BridgeCommands.Command<
    Types.Common.Downloader.GetPostProcessingStatusParameters,
    Types.Common.Downloader.PostProgressStatusReturn
    > = {
    legacyCommand: 'QUERY_IPC_EXTENSION_MESSAGE',
    system: 'CrimsonNative',
    module: 'Downloader',
    method: 'GetPostProcessingStatus',
    persistent: false
};

/** This object was automatically generated by generate-commands. DO NOT MODIFY IT BY HAND. */

const StartPostProcessing: BridgeCommands.Command<
    Types.Common.Downloader.StartPostProcessingParameters,
    Types.Common.Downloader.PostProgressStatusReturn
    > = {
    legacyCommand: 'QUERY_IPC_EXTENSION_MESSAGE',
    system: 'CrimsonNative',
    module: 'Downloader',
    method: 'StartPostProcessing',
    persistent: false
};

/** This object was automatically generated by generate-commands. DO NOT MODIFY IT BY HAND. */

const TriggerAutoUpdate: BridgeCommands.Command<
    Types.Common.Downloader.TriggerAutoUpdateParameters,
    Types.Common.Downloader.TriggerAutoUpdateReturn
    > = {
    legacyCommand: 'QUERY_IPC_EXTENSION_MESSAGE',
    system: 'CrimsonNative',
    module: 'Downloader',
    method: 'TriggerAutoUpdate',
    persistent: false
};

/** This object was automatically generated by generate-commands. DO NOT MODIFY IT BY HAND. */

const GetAutoUpdateStatus: BridgeCommands.Command<
    Types.Common.Downloader.GetAutoUpdateStatusParameters,
    Types.Common.Downloader.AutoUpdateStatusReturn
    > = {
    legacyCommand: 'QUERY_IPC_EXTENSION_MESSAGE',
    system: 'CrimsonNative',
    module: 'Downloader',
    method: 'GetAutoUpdateStatus',
    persistent: false
};

/** This object was automatically generated by generate-commands. DO NOT MODIFY IT BY HAND. */

const RegisterCheckForUpdateProgress: BridgeCommands.Command<
    {},
    Types.Common.Downloader.CheckForUpdateStatus
    > = {
    legacyCommand: 'QUERY_IPC_EXTENSION_MESSAGE',
    system: 'CrimsonNative',
    module: 'Downloader',
    method: 'RegisterCheckForUpdateProgress',
    persistent: true
};

/** This object was automatically generated by generate-commands. DO NOT MODIFY IT BY HAND. */

const RegisterDownloadProgress: BridgeCommands.Command<
    {},
    Types.Common.Downloader.DownloadProgressStatus
    > = {
    legacyCommand: 'QUERY_IPC_EXTENSION_MESSAGE',
    system: 'CrimsonNative',
    module: 'Downloader',
    method: 'RegisterDownloadProgress',
    persistent: true
};

/** This object was automatically generated by generate-commands. DO NOT MODIFY IT BY HAND. */

const RegisterPostProcessingProgress: BridgeCommands.Command<
    {},
    Types.Common.Downloader.PostProcessingStatusInfo
    > = {
    legacyCommand: 'QUERY_IPC_EXTENSION_MESSAGE',
    system: 'CrimsonNative',
    module: 'Downloader',
    method: 'RegisterPostProcessingProgress',
    persistent: true
};

/** This object was automatically generated by generate-commands. DO NOT MODIFY IT BY HAND. */

const RegisterAutoUpdateProgress: BridgeCommands.Command<
    {},
    Types.Common.Downloader.AutoUpdateProgressInfo
    > = {
    legacyCommand: 'QUERY_IPC_EXTENSION_MESSAGE',
    system: 'CrimsonNative',
    module: 'Downloader',
    method: 'RegisterAutoUpdateProgress',
    persistent: true
};

/** This object was automatically generated by generate-commands. DO NOT MODIFY IT BY HAND. */

const CreateProfileFromSourceProfile: BridgeCommands.Command<
    Types.Common.Downloader.CreateProfileFromSourceProfileParameters,
    Types.Common.Downloader.CreateProfileFromSourceProfileReturn
    > = {
    legacyCommand: 'QUERY_IPC_EXTENSION_MESSAGE',
    system: 'CrimsonNative',
    module: 'Downloader',
    method: 'CreateProfileFromSourceProfile',
    persistent: false
};

/** This object was automatically generated by generate-commands. DO NOT MODIFY IT BY HAND. */

const GetUpdateChannel: BridgeCommands.Command<
    Types.Common.Downloader.GetUpdateChannelParameters,
    Types.Common.Downloader.GetUpdateChannelReturn
    > = {
    legacyCommand: 'QUERY_IPC_EXTENSION_MESSAGE',
    system: 'CrimsonNative',
    module: 'Downloader',
    method: 'GetUpdateChannel',
    persistent: false
};

/** This object was automatically generated by generate-commands. DO NOT MODIFY IT BY HAND. */

const SetUpdateChannel: BridgeCommands.Command<
    Types.Common.Downloader.SetUpdateChannelParameters,
    Types.Common.Downloader.SetUpdateChannelReturn
    > = {
    legacyCommand: 'QUERY_IPC_EXTENSION_MESSAGE',
    system: 'CrimsonNative',
    module: 'Downloader',
    method: 'SetUpdateChannel',
    persistent: false
};

export const Downloader = {
GetFirstBootTimeAfterInstall,
GetMaxDaysBetweenReleases,
CheckForUpdate,
GetLatestUpdateCheckTime,
GetTaskDownloadStatus,
GetDownloadStatus,
StartDownload,
StartDownloadAndPostProcess,
ScheduleDownloadAndPostProcess,
PauseDownload,
ResumeDownload,
ResumeDownloadAndPostProcess,
StopDownload,
GetPostProcessingStatus,
StartPostProcessing,
TriggerAutoUpdate,
GetAutoUpdateStatus,
RegisterCheckForUpdateProgress,
RegisterDownloadProgress,
RegisterPostProcessingProgress,
RegisterAutoUpdateProgress,
CreateProfileFromSourceProfile,
GetUpdateChannel,
SetUpdateChannel
};
